module.exports = __webpack_public_path__ + "img/index-rcfw1.5b21a336.png";